import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        error: null,
        loading: true
      },
      live: {
        list: [],
        error: null,
        loading: true
      },
      pronostics: {
        list: [],
        error: null,
        loading: true
      },
      lastRequestTimestamps: {}
    };

    super('match', defaultState, {
      useLocalStorage: false
    });

    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.MATCH.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.MATCH.LIST_ALL.REFRESHED, (data) => {
      console.log('🚀 ~ Store ~ setupEvents ~ data:', data);
      if (Array.isArray(data.data)) {
        this.state.list_all.list = [
          ...data.data,
          ...this.state.list_all.list.filter(
            (el) => !data.data.find((elSaved) => elSaved.id == el.id)
          )
        ];
      }
      console.log(
        '🚀 ~ Store ~ setupEvents ~ this.state.list_all.list:',
        this.state.list_all.list
      );
      this.state.list_all.loading = false;
      this.state.list_all.error = Array.isArray(data.data)
        ? null
        : 'Mauvais format de donnée';
    });

    this.on(constants.EVENTS.MATCH.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error?.message || error;
      this.state.list_all.list = [];
    });

    this.on(constants.EVENTS.MATCH.LIVE.REFRESHING, () => {
      this.state.live.loading = true;
      this.state.live.error = null;
    });

    this.on(constants.EVENTS.MATCH.LIVE.REFRESHED, (data) => {
      this.state.live.list = Array.isArray(data) ? data : [];
      this.state.live.loading = false;
      this.state.live.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });

    this.on(constants.EVENTS.MATCH.LIVE.REFRESH_ERROR, (error) => {
      this.state.live.loading = false;
      this.state.live.error = error?.message || error;
      this.state.live.list = [];
    });

    this.on(constants.EVENTS.MATCH.PRONOSTICS.REFRESHING, () => {
      !this.state.pronostics &&
        (this.state.pronostics = { ...this.defaultState.pronostics });
      this.state.pronostics.loading = true;
      this.state.pronostics.error = null;
    });

    this.on(constants.EVENTS.MATCH.PRONOSTICS.REFRESHED, (data) => {
      this.state.pronostics.list = Array.isArray(data) ? data : [];
      this.state.pronostics.loading = false;
      this.state.pronostics.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });

    this.on(constants.EVENTS.MATCH.PRONOSTICS.REFRESH_ERROR, (error) => {
      this.state.pronostics.loading = false;
      this.state.pronostics.error = error?.message || error;
      this.state.pronostics.list = [];
    });
  }

  getLastRequestTimestamp = (key) =>
    this.state.lastRequestTimestamps?.[key] || 0;
  setLastRequestTimestamp = (key) => {
    !this.state.lastRequestTimestamps &&
      (this.state.lastRequestTimestamps = {});
    this.state.lastRequestTimestamps[key] = Date.now();
  };
}

export default Store;
// new Store();
